import { shareSNS } from './lib/_share.js';
import { Scroll } from './lib/_scroll.js';

export var common = {
	scrl: "",
	beforeW: 0,
	init: ()=>{
		common.start();
	},
	start: function(){
		let resizeFlag;
		let resizeTimer = null;
		let $body = document.getElementsByTagName('body')[0];
		
		common.resize();
		common.nav();
		common.scrl = new Scroll();
		
		/* window resize
		----------------------------- */
		var resizeCallback = function() {
			common.resize();
			resizeTimer = null;
		};
		window.addEventListener("resize", function(){
			if( !$body.classList.contains("resize") ){
				$body.classList.add("resize");
			}
			if(resizeTimer) {
				clearTimeout(resizeTimer);
			}
			resizeTimer = setTimeout(resizeCallback, 300);
		}, false);
	},
	nav: ()=>{
		let $btnMenu 	= document.querySelector("[data-menu]");
		if($btnMenu){
			//single handlers
			const eventListeners = [
				{ element: $btnMenu, type: "click", handler: common.toggleMenu}
			]
			eventListeners.forEach( ( el ) => {
				if(el.element){
					el.element.removeEventListener(el.type, el.handler, false);
					el.element.addEventListener(el.type, el.handler, false);
				}
			});
		}
		
		let $btnAccordion 	= document.querySelectorAll("[data-btn-accordion]");
		let $btnScroll 		= document.querySelectorAll("[data-scroll]");
		let $btnScrollId	= document.querySelectorAll("[data-scroll-id]");
		const eventListenersMultiple = [
			{ elements: $btnAccordion, type: "click", handler: common.toggleAccordion },
			{ elements: $btnScroll, type: "click", handler: common.scrollToPos },
			{ elements: $btnScrollId, type: "click", handler: common.scrollToPosID }
		];
		eventListenersMultiple.forEach( ( el ) => {
			el.elements.forEach( ( element, index )=> {
				element.removeEventListener(el.type, el.handler, false);
				element.addEventListener(el.type, el.handler, false);
			});
		});
	},
	toggleMenu: function(e){
		let $html = document.documentElement;
		if( !$html.classList.contains("show_menu") ){
			$html.classList.add("show_menu");
		}else{
			$html.classList.remove("show_menu");
		}
	},
	toggleAccordion: function(e){
		e.preventDefault();
		console.log("toggle")
		let $this 		= e.currentTarget;
		let index 		= $this.getAttribute("data-btn-accordion");
		let $accordions = document.querySelectorAll("[data-accordion]");
		let $target 	= $accordions[index];
		let $targetContent = $target.querySelector(".c-accordion_inner");
		if( !$this.classList.contains("open") ){
			contentH = $targetContent.clientHeight;
			$this.classList.add("open");
		}else{
			contentH = 0;
			$this.classList.remove("open");
		}
		$target.style.height = contentH + "px";
	},
	closeAllAccordion: function(){
		let $btnAccordion = document.querySelectorAll("[data-btn-accordion]");
		let $accordions = document.querySelectorAll("[data-accordion]");
		$btnAccordion.forEach( ($btn, index) => {
			if( $btn.classList.contains("open") ){
				$accordions[index].style.height = "0px";
				$btn.classList.remove("open");
			}
		});
	},
	resize: function(){
		var winW 	= window.innerWidth;
		var winH 	= window.innerHeight;
		let $body 	= document.getElementsByTagName('body')[0];
		
		addressbarH();
		
		common.getScrollBar();
		/*
		if(common.scrl){
			common.scrl.checkBlock();
			common.scrl.checkScroll();
		}
		*/
		setTimeout(function(){
			if( $body.classList.contains("resize") ){
				$body.classList.remove("resize");
			}
		},300);
		function addressbarH(){
			if(common.beforeW != winW){
				// 100vh、アドレスバーが出てる時に対応
				let vh = window.innerHeight * 0.01;
				document.documentElement.style.setProperty("--vh", `${vh}px`);
			}
		}
		common.beforeW = winW;
	},
	getScrollBar: function(){
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
	},
	scrollToPos: function(e){
		e.preventDefault();
		let margin = parseInt( this.getAttribute("data-scroll") );
		if( margin === "" || !margin){
			margin = 0;
		}
		let id 		= e.currentTarget.getAttribute("href");
		
		let $dom 	= document.querySelector(id);
		let posY 	= Math.floor( $dom.getBoundingClientRect().top + window.pageYOffset ) - margin;
		//console.log(posY, margin)
		window.scrollTo({
			top: posY,
			behavior: "smooth"
		});
		common.closeAllAccordion();
	},
	scrollToPosID: function(e){
		e.preventDefault();
		let margin = parseInt( this.getAttribute("data-scroll-id") );
		if( margin === "" || !margin){
			margin = 0;
		}
		let id 		= e.currentTarget.getAttribute("href");
		let $dom 	= document.querySelector(id);
		let posY 	= Math.floor( $dom.getBoundingClientRect().top + window.pageYOffset ) - margin;
		
		//console.log(posY, margin)
		window.scrollTo({
			top: posY,
			behavior: "smooth"
		});
		common.closeAllAccordion();
		history.pushState(null, '', id);
	}
}
